import React, { useEffect, useState } from 'react';

const PAGE_SIZE = 4;
const Experience = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);

  useEffect(() => {
    fetch('/experience.json')
      .then(res => {
        if (!res.ok) throw new Error('Failed to load experience data');
        return res.json();
      })
      .then(setData)
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <section className="resume-experience"><p>Loading...</p></section>;
  if (error) return <section className="resume-experience"><p>Error: {error}</p></section>;

  const visibleExperiences = data.slice(0, visibleCount);
  const hasMore = visibleCount < data.length;

  return (
    <section className="resume-experience">
      <h2>Experience</h2>
      {visibleExperiences.map((exp, idx) => (
        <div className="experience-item" key={idx}>
          <h3>{exp.role} @ {exp.company}</h3>
          <p>{exp.duration}</p>
          <p>{exp.description}</p>
        </div>
      ))}
      {hasMore && (
        <div style={{textAlign: 'center', marginTop: '16px'}}>
          <button className="load-more-btn" onClick={() => setVisibleCount(c => c + PAGE_SIZE)}>
            Load More
          </button>
        </div>
      )}
    </section>
  );
};

export default Experience;
